import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { HttpService } from "./HttpService";

const ProtectedRoute = () => {
  const { user, saml } = useSelector((store: any) => store.login);
  if (!isLoggedUser(user)) {
    console.log(`saml="${saml}"`);
    if (saml) {
      return <Navigate to="/saml" />;
    } else {
      return <Navigate to="/login" />;
    }
  }
  return (
    <></>
  )
};

/**
 * Invoke /checknavigation route and returns data response.
 * Server response `navigation` can be "/dashboard", "/prenotation" or "/pharmacyList"
 * @returns {{ navigation: string, eventId: string, namePharmacy: string }} Server response.
 */
export const CheckNavigation = async () => {
  let result = await HttpService.get(`${process.env.REACT_APP_API}/t4event/api/v01/event/checknavigation`);
  return result.data;
}

/**
 * Check if the client is logged in or not.
 * Based on `user` variable, set as empty object in initialization and after logout.
 * @param user User object stored locally.
 * @returns {boolean}
 */
export const isLoggedUser = (user: any) => {
  return Object.keys(user).length > 0;
};

export default ProtectedRoute

